import { type ImagePayload } from "../nodes/image/ImageNode";
import { createCommand, type LexicalCommand } from "lexical";

export type InsertImagePayload = Readonly<ImagePayload>;

export const INSERT_IMAGE_COMMAND: LexicalCommand<InsertImagePayload> = createCommand();

export const EDITOR_INSERT_IMAGE_EVENT = "editor-insert-image-event";

export function insertImageIntoMarkdownEditor(src: string) {
  const event = new CustomEvent(EDITOR_INSERT_IMAGE_EVENT, {
    detail: { src },
  });
  document.dispatchEvent(event);
}
